import { render } from "./PlayButton.vue?vue&type=template&id=4dfa3b9c"
import script from "./PlayButton.vue?vue&type=script&lang=js"
export * from "./PlayButton.vue?vue&type=script&lang=js"
script.render = render

export default script